import { OPEN_STREET_MAPS_LINK } from 'common/constants';
import leaflet from 'leaflet';
import { logger } from 'common/utils';

export const CanvasTileLayer = leaflet.GridLayer.extend({
  createTile(coords) {
    const tile = leaflet.DomUtil.create('canvas', 'leaflet-tile');
    const ctx = tile.getContext('2d')!;
    const tileSize = this.getTileSize();

    tile.width = tileSize.x;
    tile.height = tileSize.y;

    const img = new Image();
    img.crossOrigin = 'Anonymous';
    img.onload = () => {
      ctx.drawImage(img, 0, 0, tileSize.x, tileSize.y);

      // Manipulate pixels here to change water to blue
      const imageData = ctx.getImageData(0, 0, tileSize.x, tileSize.y);
      const { data } = imageData;

      for (let i = 0; i < data.length; i += 4) {
        const r = data[i];
        const g = data[i + 1];
        const b = data[i + 2];
        // If the pixel is close to the water color rgba(169, 211, 223)
        if (Math.abs(r - 169) < 10 && Math.abs(g - 211) < 10 && Math.abs(b - 223) < 10) {
          // Change water to a lighter blue (you can adjust these numbers)
          data[i] = 29; // Red channel
          data[i + 1] = 162; // Green channel
          data[i + 2] = 216; // Blue channel
        } else if (Math.abs(r - 193) < 1 && Math.abs(g - 201) < 1 && Math.abs(b - 204) < 0.1) {
          // Set to specific shade of blue (#1da2d8, which is RGB: 29, 162, 216)
          data[i] = 29; // Red channel
          data[i + 1] = 162; // Green channel
          data[i + 2] = 216; // Blue channel
        } else if (Math.abs(r - 173) < 2 && Math.abs(g - 204) < 2 && Math.abs(b - 235) < 2) {
          // Set to blue (#1da2d8, which is RGB: 28, 162, 216)
          data[i] = 29; // Red channel
          data[i + 1] = 162; // Green channel
          data[i + 2] = 216; // Blue channe
        } else {
          // Convert other areas to grayscale
          const grey = 0.04 * r + 0.8 * g + 0.2 * b;
          data[i] = grey; // Red channel
          data[i + 1] = grey; // Green channel
          data[i + 2] = grey; // Blue channel
        }
      }

      ctx.putImageData(imageData, 0, 0);
    };

    img.src = `${OPEN_STREET_MAPS_LINK}/${coords.z}/${coords.x}/${coords.y}.png`;
    return tile;
  },
});

export const addZoomControl = (leafletMap: leaflet.Map) =>
  leaflet.control
    .zoom({
      position: 'topright',
    })
    .addTo(leafletMap);

// DOCS FOR NOMINATIM: https://nominatim.org/release-docs/develop/api/Search/

export const searchOpenStreetMap = async (query: string, lang: string, countryCode?: string): Promise<any> => {
  try {
    const params = new URLSearchParams({
      format: 'json',
      q: query,
      'accept-language': lang,
      limit: '10', // Limit results to 10 items
      addressdetails: '1', // Get address details in response
    });

    if (countryCode) {
      params.append('countrycodes', countryCode.toLowerCase());
    }

    const response = await fetch(`https://nominatim.openstreetmap.org/search?${params.toString()}`, {});

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    logger.error({ error: 'Error searching OpenStreetMap:', extraData: error });
    return [];
  }
};
